import SocialMedia from "components/About/SocialMedia";
import LatestWorkshop from "components/Homepage/LatestWorkshop";
import PriceSection from "components/Service/PriceSection";
import HeroTrainingBusiness from "components/TrainingBusiness/HeroTrainingBusiness";
import ListTrainingBusiness from "components/TrainingBusiness/ListTrainingBusiness";
import MissionTraining from "components/TrainingBusiness/MissionTraining";
import QuoteTrainingBusiness from "components/TrainingBusiness/QuoteTrainingBusiness";
import React from "react";

const TrainingBusiness = () => {
  return (
    <div>
      <HeroTrainingBusiness />
      <QuoteTrainingBusiness />
      <MissionTraining />
      <ListTrainingBusiness />
      <PriceSection />
    </div>
  );
};

export default TrainingBusiness;
